import { render } from "./EonAddAreasPopup.vue?vue&type=template&id=1063d59a"
import script from "./EonAddAreasPopup.vue?vue&type=script&lang=js"
export * from "./EonAddAreasPopup.vue?vue&type=script&lang=js"

import "./EonAddAreasPopup.vue?vue&type=style&index=0&id=1063d59a&lang=less"

import exportComponent from "/Users/kacper/IdeaProjects/e.on-portal-awarie/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__